import gql from 'graphql-tag';

export default gql`
  fragment userFragment on UserType {
    id
    email
    avatar
    fullName
    createdAtText
    updatedAtText
    deactivatedAtText
  }
`;
